import { useAuth } from "@via/hooks/useAuth";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UserInvitation from "@via/pages/organization/user-invitation";
import { canManageOrganization } from "@via/hooks/organization-access.ts";

const Users = () => {
  const navigate = useNavigate();
  const { organizationId = "" } = useParams();
  const { user } = useAuth();

  useEffect(() => {
    // undefined = the user has not loaded yet; only a definite "no" redirects.
    if (canManageOrganization(user, organizationId) === false) {
      navigate(`/organization/${organizationId}/activity`);
      return;
    }
  }, [user, organizationId]);

  return (
    <div className="w-3/4 m-auto">
      <UserInvitation organizationId={organizationId} />
    </div>
  );
};

export default Users;
